<div>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div>
      <label for="email" translate>app.modal.invite.email</label>
      <input type="text" formControlName="email" id="email"
             [ngClass]="{ 'invalid': submitted && fg.email.errors }"/>

      <div *ngIf="submitted && fg.email.errors">
        <div *ngIf="fg.email.errors.required" translate>app.modal.invite.email.empty.error</div>
      </div>
    </div>

    <div>
      <label for="types" translate>app.modal.invite.type</label>
      <select formControlName="types" id="types" multiple>
        <option *ngFor="let type of userTypeService.getTypes(false)"
                [value]="type.id">{{type.name}}</option>
      </select>
    </div>

    <div>
      <label for="permissions" translate>app.modal.invite.permission</label>
      <select formControlName="permissions" id="permissions" multiple>
        <option *ngFor="let permission of permissionService.getPermissions(false)"
                [value]="permission.id">{{permission.name}}</option>
      </select>
    </div>

    <button [disabled]="loading" translate>app.modal.invite.button</button>
    <div *ngIf="error">{{error}}</div>
  </form>
</div>
